import axios from 'axios';

const get = () => axios.get('/alcadas/solicitacoes');

const create = data => axios.post('/alcadas/solicitacoes', data);

const update = (id, data) => axios.put(`/alcadas/solicitacoes/${id}`, data);

const remove = id => axios.delete(`/alcadas/solicitacoes/${id}`);

export default {
  get,
  create,
  update,
  remove,
};
